import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  card: null
}
const requestPhysicalCardSlice = createSlice({
  name: 'requestPhysicalCard',
  initialState,
  reducers: {
    initRequestPhysicalCard(state, action) {
      const { card } = action.payload
      state.card = card
    }
  },
})

export const selectCard = (state) => state.requestPhysicalCard?.card

export const { initRequestPhysicalCard } = requestPhysicalCardSlice.actions

export default requestPhysicalCardSlice.reducer
